import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  // ApiResponse,
  ApiClientService,
  ApiResponse
} from './../../shared/services/api-client.service';
import {
  AB_API_REPORTING_TABLE,
  AB_API_REPORTING_DOWNLOAD,
  AB_API_BASE,
  AB_API_DOMAIN
} from './../../shared/constants';
import * as moment from 'moment';

interface ReportingRequest {
  fromDate: moment.Moment;
  toDate: moment.Moment;
  selectedReportType: string;
  selectedReportFormat?: string;
  pageNumber?: string;
}

interface ReportingResponse extends ApiResponse {
  items: Array<any>;
  totalNumberOfRecordsAvailable: number;
  type: string;
}

const REPORTING_EVENTS = {
  SIGN_IN: 'auditReportSignInLog',
  MONEY_TRANSFER: 'auditReportMoneyTransfer',
  SEARCHING: 'auditReportSearching',
  SCROLLING: 'auditReportScrolling',
  STOP_LOADING: 'stopLoading'
};

@Injectable({
  providedIn: 'root'
})
export class ReportingService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_REPORTING_TABLE);
  }

  getReport(
    filter: ReportingRequest,
    pageNumber: number
  ): Observable<ReportingResponse> {
    return this.get({
      fromDate: filter.fromDate.toDate().toDateString(),
      toDate: filter.toDate.toDate().toDateString(),
      selectedReportType: filter.selectedReportType,
      pageNumber: pageNumber
    });
  }

  getDownloadUrl(): string {
    return AB_API_DOMAIN + AB_API_BASE + AB_API_REPORTING_DOWNLOAD;
  }

  public download(request: ReportingRequest): string {
    let params = new HttpParams();
    params = params.append(
      'fromDate',
      request.fromDate.toDate().toDateString()
    );
    params = params.append('toDate', request.toDate.toDate().toDateString());
    params = params.append('selectedReportType', request.selectedReportType);
    params = params.append(
      'selectedReportFormat',
      request.selectedReportFormat
    );
    return this.getDownloadUrl() + '?' + params.toString();
  }
}

export { REPORTING_EVENTS, ReportingRequest, ReportingResponse };
